module.exports = __webpack_public_path__ + "img/usdt.d7ecbbc7.svg";